import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import AddLiquidity from './index'

export function RedirectToAddLiquidity() {
  return <Navigate to="/add/" replace />
}

const OLD_PATH_STRUCTURE = /^(0x[a-fA-F0-9]{40})-(0x[a-fA-F0-9]{40})$/

export function RedirectOldAddLiquidityPathStructure() {
  const { token0 = '' } = useParams<{ token0: string }>()
  const match = token0.match(OLD_PATH_STRUCTURE)
  if (match?.length) {
    return <Navigate to={`/add/${match[1]}/${match[2]}`} replace />
  }

  return <AddLiquidity />
}

export function RedirectDuplicateTokenIds() {
  const { token0 = '', token1 = '' } = useParams<{ token0: string; token1: string }>()
  if (token0.toLowerCase() === token1.toLowerCase()) {
    return <Navigate to={`/add/${token0}`} replace />
  }
  return <AddLiquidity />
}
